import { Typography } from "@mui/material";

export const Privacy = () => {
	return (
		<>
			<Typography variant="h6">
				By using this site, you agree to having your public IP address
				submitted to the database upon submitting your first review.
			</Typography>
		</>
	);
};
